import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { debounceTime, pluck, shareReplay } from 'rxjs/operators';
import { Filter } from '../models/filter.model';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  $filter = new ReplaySubject<Filter>(1);
  filter$ = this.$filter.pipe(debounceTime(250), shareReplay(1));
  filterQuery$ = this.filter$.pipe(pluck('query'));
  filterQueryLowerCase$ = this.filter$.pipe(pluck('queryLowerCase'));

  constructor() { }

  public update(filter: Filter) {
    this.$filter.next(filter);
  }
}
